import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { GroupRequest } from './group-request.model';
import { GetGroupRequest } from './get-group-request.model';

@Injectable({ providedIn: 'root' })
export class GroupRequestService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getGroupRequests(): Promise<GetGroupRequest[]> {
    let promise = new Promise<GetGroupRequest[]>((resolve, reject) => {
      return this.http
        .get<GetGroupRequest[]>(this.apiHost + '/group/pullrequests')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Group Requests', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  acceptJoinRequest(requestId: number): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost + '/Group/AcceptJoinRequest?id=' + requestId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Accept Group Requests', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  denyJoinRequest(requestId: number): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost + '/Group/DenyJoinRequest?id=' + requestId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Deny Group Requests', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
